export default __webpack_public_path__ + "static/media/gift.fc535526.png";